module.exports = __webpack_public_path__ + "static/media/img152.b46922b8.jpg";